import React from "react";
import Icon from "./Icon";

function LinkChip({ link }) {
  const isExternal = link.href.startsWith("http");
  return (
    <a
      className="link-chip"
      href={link.href}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
    >
      <Icon name={link.kind === "email" ? "mail" : "arrow-up-right"} size={13} />
      {link.label}
    </a>
  );
}

function nameParts(name) {
  const parts = name.trim().split(" ");
  if (parts.length < 2) return { first: name, last: "" };
  const last = parts.pop();
  return { first: parts.join(" "), last };
}

export default function Hero({ data, onContact, onDownload }) {
  const { first, last } = nameParts(data.name);
  return (
    <section className="hero hero-signal">
      <h1 className="hero-name">
        {first} {last && <em>{last}</em>}
      </h1>
      <div className="hero-role">{data.role} · {data.location}</div>
      <p className="hero-bio">{data.bio}</p>
      <div className="links" style={{ marginTop: 18 }}>
        {data.links.map((l) => <LinkChip key={l.label} link={l} />)}
      </div>
      <div className="hero-actions">
        <button className="btn btn-primary" onClick={onDownload}>
          <Icon name="arrow-down-to-line" size={16} /> Download CV
        </button>
        <button className="btn btn-secondary" onClick={onContact}>
          <Icon name="mail" size={16} /> Get in touch
        </button>
      </div>
    </section>
  );
}
